import { GeneralService } from './../../services/general.service';
import { Title } from '@angular/platform-browser';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from '../message.service';

@Component({
  selector: 'app-discussion',
  templateUrl: './discussion.component.html',
  styleUrls: ['./discussion.component.scss'],
})
export class DiscussionComponent implements OnInit {
  chat: any = [];
  id: number;
  type: string;
  messages: any;
  isRequesting: boolean;
  isSubmitting = false;
  constructor(
    private titleService: Title,
    private route: ActivatedRoute,
    public messageService: MessageService,
    public generalService: GeneralService
  ) {}

  ngOnInit() {
    this.titleService.setTitle('Autoscoop - Mates Ride Discussion');
    this.route.params.subscribe(params => {
      this.id = +params.id;
      this.messageService.fetchMessages(this.id);
    });
    // console.log(this.messageService.messages);
  }
}
